import _taggedTemplateLiteral from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3;

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import { useIsDesktop } from '../../../hooks';
import { useMenuOnClose } from '../hooks';
var StyledButton = styled(Button).attrs(function () {
  return {
    underline: 'none'
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-transform: none;\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return "\n    color: ".concat(theme.palette.primary.contrastText, ";\n  ");
});
var StyledLi = styled('li')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  list-style: none;\n  ", "\n"])), function (_ref2) {
  var isDesktop = _ref2.isDesktop;
  return "\n    ".concat(StyledButton, " {\n      ").concat(isDesktop ? '' : "\n        padding: 8px 16px;\n        width: 100%;\n        justify-content: flex-start;\n      ", ";\n    }\n  ");
});

var MenuItem = function MenuItem(_a) {
  var children = _a.children,
      forwardedRef = _a.forwardedRef,
      onClick = _a.onClick,
      rest = __rest(_a, ["children", "forwardedRef", "onClick"]);

  var closeMenu = useMenuOnClose();
  var isDesktop = useIsDesktop();

  var onMobileItemClick = function onMobileItemClick(e) {
    onClick && onClick(e);
    closeMenu && closeMenu();
  };

  return React.createElement(StyledLi, {
    isDesktop: isDesktop
  }, React.createElement(StyledButton, Object.assign({
    onClick: isDesktop ? onClick : onMobileItemClick,
    ref: forwardedRef
  }, rest), children));
};

MenuItem.displayName = 'Navbar.MenuItem';
var MenuItemExtra = styled(forwardRef(function (props, ref) {
  return React.createElement(MenuItem, Object.assign({}, props, {
    forwardedRef: ref
  }));
}))(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])));
export default MenuItemExtra;